module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "address-box",
    on: {
      "click": _vm.toAddress
    }
  }, [_c('b'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasAddresss),
      expression: "hasAddresss"
    }]
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("收件人：" + _vm._s(_vm.addrList ? _vm.addrList.addressUser : "")), _c('i', [_vm._v(_vm._s(_vm.addrList ? _vm.addrList.addressPhone : ""))])]), _vm._v(" "), _c('p', {
    staticClass: "address"
  }, [_vm._v(_vm._s(_vm.addrList ? _vm.addrList.addressPname : "") + " " + _vm._s(_vm.addrList ? _vm.addrList.addressCname : "") + " " + _vm._s(_vm.addrList ? _vm.addrList.addressDname : "") + " " + _vm._s(_vm.addrList ? _vm.addrList.addressStreet : ""))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasAddresss),
      expression: "!hasAddresss"
    }]
  }, [_c('p', {
    staticClass: "address"
  }, [_vm._v("请设置你的收货地址")])]), _vm._v(" "), _c('b'), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3e356176", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3e356176","hasScoped":true}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/component/jorderaddress.vue
// module id = 269
// module chunks = 0